/* Manual, section-local photo/review rail. No timers, review feeds or commerce. */
(() => {
  if (typeof window === 'undefined' || customElements.get('jv-customer-stories')) return;
  class JVCustomerStories extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.rail = this.querySelector('.jvcs-track');
      this.cards = [...this.querySelectorAll('[data-jvcs-card]')];
      if (!this.rail || !this.cards.length) return;
      this.controls = this.querySelector('.jvcs-controls');
      this.progress = this.querySelector('[data-jvcs-progress]');
      this.prev = this.querySelector('[data-jvcs-prev]');
      this.next = this.querySelector('[data-jvcs-next]');
      this.status = this.querySelector('[data-jvcs-status]');
      this.status.textContent = '';
      this.controller = new AbortController();
      const on = (node, type, fn) => node.addEventListener(type, fn, {signal:this.controller.signal});
      on(this.prev,'click',()=>this.go(this.index-1,true));
      on(this.next,'click',()=>this.go(this.index+1,true));
      on(this.rail,'scroll',()=>this.sync());
      on(this.rail,'keydown',event=>{
        if (event.target!==this.rail || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        this.go(event.key==='Home'?0:event.key==='End'?this.positions.length-1:this.index+(event.key==='ArrowRight'?1:-1),true);
      });
      on(this.progress,'click',event=>{const button=event.target.closest('button[data-jvcs-position]');if(button)this.go(Number(button.dataset.jvcsPosition),true);});
      on(document,'shopify:block:select',event=>{
        if(event.detail?.sectionId!==this.dataset.sectionId)return;
        const index=this.cards.findIndex(card=>card.dataset.blockId===event.detail.blockId);
        if(index>=0){this.go(Math.min(index,this.positions.length-1),false);this.cards[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});}
      });
      on(window,'resize',()=>this.measure());
      this.observer = new ResizeObserver(()=>this.measure()); this.observer.observe(this.rail);
      this.measure();
    }
    measure() {
      const max=Math.max(0,this.rail.scrollWidth-this.rail.clientWidth);
      const first=this.cards[0].offsetLeft;
      const positions=[...new Set(this.cards.map(card=>Math.min(max,card.offsetLeft-first)))];
      if(JSON.stringify(positions)!==JSON.stringify(this.positions)){
        this.positions=positions;this.progress.replaceChildren();
        positions.forEach((_,index)=>{
          const button=document.createElement('button');button.type='button';button.dataset.jvcsPosition=index;
          button.setAttribute('aria-label',`Show customer stories starting at ${index+1}`);
          button.setAttribute('aria-controls',this.rail.id);this.progress.append(button);
        });
      }
      this.controls.hidden=max<2;
      this.sync();
      if(this.status.textContent)this.status.textContent=`Customer stories, position ${this.index+1} of ${this.positions.length}.`;
    }
    sync() {
      if(!this.positions?.length)return;
      this.index=this.positions.reduce((best,value,index)=>Math.abs(value-this.rail.scrollLeft)<Math.abs(this.positions[best]-this.rail.scrollLeft)?index:best,0);
      this.prev.disabled=this.next.disabled=this.positions.length<2;
      [...this.progress.children].forEach((button,index)=>button.setAttribute('aria-current',String(index===this.index)));
    }
    go(index,announce) {
      const count=this.positions?.length||0;
      if(!count)return;
      index=((index%count)+count)%count;
      this.rail.scrollTo({left:this.positions[index],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      if(announce)this.status.textContent=`Customer stories, position ${index+1} of ${this.positions.length}.`;
    }
    disconnectedCallback(){this.cleanup();}
    cleanup(){this.controller?.abort();this.observer?.disconnect();this.positions=null;}
  }
  customElements.define('jv-customer-stories',JVCustomerStories);
})();
